import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StageService } from 'src/app/_services/stage/stage.service';
import { Stage } from 'src/app/Model/stage';
import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
@Component({
  selector: 'ngbd-modal-content',
  template: `
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Card Recipe</title>
  <style>

  .wrapper {

    color: #000;
    font-family: 'Muli', sans-serif;
    font-size: 1rem;
    background-color: #F1E8E6;
    display: -ms-grid;
    place-items: center;
  }
  
  .card {
    background-color: #fff;
    padding: 1em;
    border-radius: 1em;
    max-width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
    -webkit-box-shadow: 0px 17px 34px -20px #f55951;
            box-shadow: 0px 17px 34px -20px #f55951;
  }
  
  .card img {
    border-radius: 0.5em;
    -o-object-fit: cover;
       object-fit: cover;
    height: 250px;
    width: 200px;
  }
  
  .card__container {
    position: relative;
    -webkit-box-flex: 2;
        -ms-flex-positive: 2;
            flex-grow: 2;
    margin-left: 1.4em;
  }
  
  .card__title {
    font-size: 1.6rem;
    font-weight: 700;
    margin: 0.7em 0;
  }
  
  .card__text {
    font-size: 1rem;
    margin-bottom: 0.8em;
    margin-right: 5em;
    width: 33ch;
  }
  
  .fa-heart {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.6em;
    border: 1px solid #F1E8E6;
    border-radius: 100%;
  }
  
  .stars {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
        -ms-flex-direction: row;
            flex-direction: row;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
  }
  
  .stars__text {
    font-size: 1rem;
    font-weight: 700;
    opacity: 0.5;
    margin-left: 0.5em;
  }
 
  </style>
  <!-- Reset styles -->
  <link rel="stylesheet" href="https://unpkg.com/modern-css-reset/dist/reset.min.css" />
  <!-- Google Fonts Muli -->
  <link href="https://fonts.googleapis.com/css2?family=Muli:wght@300;400;700&display=swap" rel="stylesheet"> 
  <!-- Icons -->
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.14.0/css/all.css" integrity="sha384-HzLeBuhoNPvSl5KYnjx0BT+WB0QEEqLprO+NBkkk5gbc67FTaL7XIGa2w1L0Xbgc" crossorigin="anonymous">
  <div class="modal-header" >
  <button  aria-hidden="true" type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
  &times;
  </button>
</div>
  <section class="wrapper" >
      <div class="card">
      <img  src="http://notregrandbleu.org/assets/img/posts/{{data.image}}"  class="img-fluid" alt="Responsive image">
       
          <div class="card__container">
            
              <p class="card__title">{{ data.title}}</p>
              <p class="card__text">
              {{ data.description}}
              </p>
              <div class="stars" >
                  <p class="stars__text">{{ data.date | date}}</p>
              </div>
          </div>
      </div>
  </section>
  `
})
export class NgbdModalContent implements OnInit {
  @Input() data;
  datePipe: DatePipe = new DatePipe('');
  constructor(public activeModal: NgbActiveModal) { }
  ngOnInit() { }
}
